var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_137_8029",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_137_8029",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADtElEQVR4nO1ZTWhUVxR+/lQplDZ1Y600lhiL2IVC+pNF4OZ+38lkgqWBaGqx6N5s1JV0FQRbSmMhYrpr142mf2lLKG3pOs1C8GclsRisRQ02xoixWho59Y59uczgm/fuZJIwH7zN8Oac871z77nfOTeKaqihhhrKxIrW1tY3SR4GMAjgPMk/SN4leZ/kXyQvAPiS5Pv6bm9v78posSCXy71E8iiA30nOlflcAfAhgI3VJLCOZB/J2RQE5j0A7gH4VG0uKAlr7dskJ0sENQ3gF/elD1pr94nIXhE5QPIjAD/oOyVITYrIOxUnYIxZTXKA5L9eAA8AnBKRnfpOEjvW2hzJL/S/RQgNJLGTCt3d3WsAfFXE6de5XG5rWrskG0gOFbH7XXNz89OhSawC8L23hG4BeDeUD5KdAG76ZIJmxm3quIPLxpjGYA7+99MA4KLn62QQ4wB2e3tiXETqgxgv7m+9T0ZjyGQ0n88/C+DPmNHbALZFFQYfZebxMgNwo6Wl5fnUBgF84qV5T7RAINkZbIk5WVH4Kj+W818ReRFARz6fX5vB/1D80FSbqQwB+LlQocrZ3NbaTQDuuCB+M8bUpfFvrd0M4J9YVj5IY0cPrmdEpMsY83KZAeS8zTqWlgyAwZidiQUVmnqQaSZCkBGRds/OG5WJunQAz5Ec9YI4U64wNMasjmszAEcqF3XpIOo0E1kzQ3IkZmMoqgZCkAHwcey/5xI7b2tr2wHgc5KnAz0/FZH7Y3rgJomHZE9c6icmoloqa7OU8DmeMJ734ufJYiTSV1Ei1trtJD9b8ktr2Wz2UFgW5dcEItHU1PSUtg9VORCd89EQEgVAR9yOiLyWSjSS3FWuaPSdZxSNpzKLxrQy3k0fZ1wAo2lJiMgWT8Yfq0ZjVQ+gTZdZKufRf/6/iZGYzdJYzWt1Q45/ngQR6fJ8n8g6fLgaMzhjrX01qjCMMY0kp2IkrmcaPsS+zONxEIBL2spGFYIx5gUdOXmVqiuIcR0+e2meIPlKVJlMjHtypj/oyJTksEdmWqfsoXy4zE95Pr5V31HoIbYTgL6CHc4ytNMS61WnuQKJ4ENsLzP9/rWC1nqd1Ou9SZJy6/rwDj3svHNirlChgmeiGEi+pWPMEj2GHoS/ukudQyT3u36ix6nYkdhh6T/Xgm3spNBpiAvsboAGa1azYFIqgCDQi0wAvVqWyyXgqt+x9vb2DdEiwgodnrnlpFdqZwvX0wD+dtN1/W1IpTjJ1xfV9XQNNdQQLQk8BDZx0rzltnYgAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.0be5ae572ec381662084f9f31abf2caf.svg";
export { ForwardRef as ReactComponent };